/* Generated code; Use nx run packages/systems/ui/icons:generate-icons
  * to regenerate this file.
  */
import React, {SVGProps} from 'react';
import type { IconProps } from '@packages/utilities/icon-support';
const createElement = React.createElement;
export default /*#__PURE__#*/ function TransparentCheckerboardDark(props: IconProps): React.ReactElement<SVGProps<SVGElement>> {
  const inputScale = props.scale ?? 1;
  const scale = typeof inputScale === 'number' ? inputScale : parseInt(inputScale, 10);
  return createElement('svg', {
      'data-icon': 'TransparentCheckerboardDark',
      'aria-hidden': true,
      focusable: false,
      width:  24 * scale,
      height: 24 * scale,
      viewBox: '0 0 24 24',
      y: props.y != null ? props.y : undefined,
      x: props.x != null ? props.x : undefined,
      className: 'bem-Svg' + (props.className ? ' ' + props.className : ''),
      style: {...{
        display: 'block',
      }, ...props.style}
    },createElement('path', {"fillRule":"evenodd","clipRule":"evenodd","d":"M4 0H0v4h4v4H0v4h4v4H0v4h4v4h4v-4h4v4h4v-4h4v4h4v-4h-4v-4h4v-4h-4V8h4V4h-4V0h-4v4h-4V0H8v4H4V0zm4 8V4h4v4H8zm0 4V8H4v4h4zm4 0V8h4v4h-4zm0 4v-4H8v4H4v4h4v-4h4zm4 0v4h-4v-4h4zm0 0v-4h4v4h-4zm0-8V4h4v4h-4z","fill":"currentColor","fillOpacity":".2"}))
}
